import React from 'react';
import InputContainer from '../InputContainer';
import {
  Autocomplete, Grid, MenuItem, TextField,
} from '@mui/material';
import maskCPF from 'components/Masks/maskCPF';
import maskCNPJ from 'components/Masks/maskCNPJ';
import MaskCEP from 'components/Masks/maskCEP';
import useAddress from 'hooks/useAddress';
import { isCpf } from '../../helpers';
import { labelField } from 'utils';

function Identification({ formik, recoverState, ...rest }) {
  const {
    values, handleBlur, handleChange, errors, touched, setFieldValue, setFieldTouched,
  } = formik;

  const cpfSelected = isCpf(values.nature);

  const {
    onBlurCep,
    states,
    selectedState,
    handleStateSelect,
    cities,
    selectedCity,
    handleCitySelect,
    loadingStates,
  } = useAddress({ setFieldValue, recoverState });

  return (
    <InputContainer title="Identificação">
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          inputProps={{ maxLength: 100 }}
          fullWidth
          id="name"
          name="name"
          value={values.name}
          label={labelField('Nome')}
          variant="outlined"
          onBlur={handleBlur}
          error={touched.name && errors.name}
          helperText={touched.name && errors.name}
          onChange={handleChange}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          InputLabelProps={{
            style: { pointerEvents: 'auto', shrink: true },
          }}
          id="nature"
          select
          label={labelField('Natureza')}
          onChange={(e) => {
            setFieldValue('nature', e.target.value);
            setFieldValue('cpfCnpj', '');
          }}
          onBlur={handleBlur}
          variant="outlined"
          value={values.nature}
          name="nature"
          error={!!(touched.nature && errors.nature)}
          helperText={
            touched.nature
            && errors.nature
          }
        >
          <MenuItem key={1} value="Pessoa Física">
            Pessoa Física
          </MenuItem>
          <MenuItem key={2} value="Pessoa Jurídica">
            Pessoa Jurídica
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          InputProps={{
            inputComponent: cpfSelected ? maskCPF : maskCNPJ,
          }}
          variant="outlined"
          id="cpfCnpj"
          label={cpfSelected ? labelField('CPF') : labelField('CNPJ')}
          errorAndHelper="cpfCnpj"
          value={values.cpfCnpj}
          onChange={(event) => {
            setFieldValue('cpfCnpj', event.target.value);
          }}
          onBlur={() => {
            setFieldTouched('cpfCnpj', true);
            if (values.nature && values.cpfCnpj) {
              setFieldValue('bank_information.ownership_nature', values.nature);
              setFieldValue('bank_information.ownership_document', values.cpfCnpj);
            }
          }}
          error={touched.cpfCnpj && errors.cpfCnpj}
          helperText={touched.cpfCnpj && errors.cpfCnpj}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          id="cep"
          label={labelField('CEP')}
          variant="outlined"
          // InputLabelProps={{ shrink: true }}
          name="cep"
          type="text"
          value={values.cep}
          onChange={handleChange}
          InputProps={{
            inputComponent: MaskCEP,
          }}
          onBlur={() => {
            setFieldTouched('cep', true);
            onBlurCep(values.cep);
          }}
          error={touched.cep && errors.cep}
          helperText={touched.cep && errors.cep}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <Autocomplete
          disabled={loadingStates}
          noOptionsText="Sem opções"
          autoComplete={false}
          id="uf"
          name="uf"
          options={states}
          value={selectedState}
          getOptionLabel={(options) => options.nome || selectedState}
          onChange={(p, v) => {
            handleStateSelect(v);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              label={labelField('Estado')}
              variant="outlined"
              onBlur={handleBlur}
              error={touched.uf && errors.uf}
              helperText={touched.uf && errors.uf}
            />
          )}
          disableClearable
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <Autocomplete
          disabled={loadingStates}
          noOptionsText="Sem opções"
          autoComplete={false}
          id="city"
          name="city"
          options={cities}
          value={selectedCity}
          getOptionLabel={(options) => options.nome || selectedCity}
          onChange={(p, v) => {
            handleCitySelect(v);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              label={labelField('Localidade')}
              variant="outlined"
              onBlur={handleBlur}
              error={touched.city && errors.city}
              helperText={touched.city && errors.city}
            />
          )}
          disableClearable
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          inputProps={{ maxLength: 100 }}
          fullWidth
          id="district"
          name="district"
          label={labelField('Bairro/Distrito')}
          variant="outlined"
          color="primary"
          value={values.district}
          onBlur={handleBlur}
          error={touched.district && errors.district}
          helperText={touched.district && errors.district}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          inputProps={{ maxLength: 100 }}
          InputLabelProps={{ shrink: values.street }}
          fullWidth
          id="street"
          name="street"
          label={labelField('Logradouro')}
          variant="outlined"
          color="primary"
          value={values.street}
          onBlur={handleBlur}
          error={touched.street && errors.street}
          helperText={touched.street && errors.street}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          inputProps={{ maxLength: 5 }}
          fullWidth
          id="number"
          name="number"
          value={values.number}
          label={labelField('Número')}
          variant="outlined"
          onBlur={handleBlur}
          error={touched.number && errors.number}
          helperText={touched.number && errors.number}
          onChange={handleChange}
          color="primary"
        />
      </Grid>
    </InputContainer>
  );
}

export default Identification;
